import { render, staticRenderFns } from "./SubtaskRejectionModal.vue?vue&type=template&id=16c48d7a&"
import script from "./SubtaskRejectionModal.vue?vue&type=script&lang=js&"
export * from "./SubtaskRejectionModal.vue?vue&type=script&lang=js&"
import style0 from "./SubtaskRejectionModal.vue?vue&type=style&index=0&id=16c48d7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports